export const NETSUITE_PAGE_TITLE = "Connect to your Netsuite Instance";

// Temporary instructions-only rollout; all connections still use NETSUITE.
const EMBEDDED_INSTRUCTIONS_ORGS = new Set([
  "47f69ad6-cd41-4288-ac73-d8e64f10b8be",
  "26302c19-e804-4b28-a646-440354a00362",
]);
export const NETSUITE_EMBEDDED_BUNDLE = {
  id: "710855",
  name: "Rutter AccountLink + mtCharge+",
};
export function shouldShowNetsuiteEmbeddedInstructions(
  orgId: string | undefined,
  isSandbox: boolean,
): boolean {
  return !isSandbox && !!orgId && EMBEDDED_INSTRUCTIONS_ORGS.has(orgId);
}
